import storyCardFragment from '@schema/story-card'
import { storySpotlightFragment } from '@components/story-spotlight/story-spotlight.fragment'
import { leaderboardFragment } from '@layouts/leaderboard/leaderboard-fragment'
import { marketingFormEmbedFragment } from '@components/marketing-form-embed/marketing-form-embed.fragment'
import gql from 'graphql-tag'
import { testimonialV2Fragment } from '@components/testimonialv2/testimonialv2.fragment'

const storyFragment = `
${storyCardFragment}
`

export const slideFragment = `
sys {
  id
}
headline
summary
ctaText
series
image {
  url
}
imageMobile {
  url
}
contentfulMetadata {
  tags {
    name
  }
}
externalLink
reference {
  __typename
  ... on Page {
    slug
  }
  ... on Story {
    ${storyFragment}
  }
  ... on Event {
    slug
  }
  ... on Tour {
    slug
  }
}
`

export const promotedLinkFragment = `
headline
summary
image {
  url
}
externalLink
reference {
  __typename
}
sys {
  id
}
`

const programFragment = `
  sys {
    id
  }
  hero {
    ${slideFragment}
  }
  heroSecondaryCtaText
  heroSecondaryCtaLink
  promotedLinksCollection(limit: 3) {
    total
    items {
        ${promotedLinkFragment}
    }
  }
  relevantStoriesHeadline
  relevantStoriesCollection {
    total
    items {
        __typename
        ... on Story {
          ${storyFragment}
        }
      }
  }
  relevantStoriesCtaText
  relevantStoriesCtaLink
  testimonialsSection {
    ${testimonialV2Fragment}
  }
  partnerLogosCollection {
    total
    items {
       url
       title
       sys {
        id
      }
    }
  }
  newsletterSignup {
    ${marketingFormEmbedFragment}
  }
  showEventsListing
  metaTitle
  metaDescription
  metaImage {
    url
  }
  leaderboardsCollection {
    items {
      ${leaderboardFragment}
    }
  }
`

export const FEATURED_STORIES_QUERY = gql`
  query BySlug($slug: String, $preview: Boolean)  {
    promotionalPageCollection(limit: 1, preview: $preview, where: {slug: $slug}) {
      items {
        featuredStoriesHeadline
        featuredStoriesCtaText
        featuredStoriesCtaLink
        featuredStoriesCollection(limit: 5) {
          total
          items {
            ${storySpotlightFragment}
          }
        }
      }
    }
  }
`

export const ACTIVITIES_QUERY = gql`
  query BySlug($slug: String, $preview: Boolean)  {
    promotionalPageCollection(limit: 1, preview: $preview, where: {slug: $slug}) {
      items {
        activitiesHeadline
        activitiesSummary
        activitiesCollection {
          total
          items {
            sys {
              id
            }
            headline
            caption
            image {
              url
              description
            }
            tileSize
          }
        }
      }
    }
  }
`

export default programFragment
